import type { AnnouncementPanelModel } from '../../types/AnnouncementPanelModel';
import type { AnnouncementDataModel } from '../../types/propTypes/AnnouncementDataModel';

export const groupHelpCenterPanels = (
  announcementData: AnnouncementDataModel[]
): AnnouncementPanelModel[] => {
  const panels = new Map<number, AnnouncementPanelModel>();

  // Sort a copy without changing the original data.
  const sortedAnnouncements = [...announcementData].sort(
    (a, b) => a.panelOrder - b.panelOrder || a.itemOrder - b.itemOrder
  );

  sortedAnnouncements.forEach((announcement) => {
    let panel = panels.get(announcement.panelOrder);

    if (!panel) {
      panel = {
        panelTitle: announcement.panelHeader,
        subPanels: [],
      };

      panels.set(announcement.panelOrder, panel);
    }

    panel.subPanels.push({
      id: announcement.id,
      panelText: announcement.panelText,
      panelUrl: announcement.panelUrl ?? '',
      panelUrlText: announcement.panelUrlText ?? '',
    });
  });

  return Array.from(panels.values());
};
